import { render, staticRenderFns } from "./BranchFilterBar.vue?vue&type=template&id=3e85b62c"
import script from "./BranchFilterBar.vue?vue&type=script&lang=js"
export * from "./BranchFilterBar.vue?vue&type=script&lang=js"
import style0 from "./BranchFilterBar.vue?vue&type=style&index=0&id=3e85b62c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BranchFilterBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports